import { HandicapMembershipAddPage } from '../../modal-screens/handicap-membership/handicap-membership-add/handicap-membership-add.page';
import { RedirectService } from '../../../../providers/redirect-service/redirect-service';
import { PromoPageType } from '../../../../data/mygolf.data';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { OfferAndAdvertisement, OnClickAction } from 'src/data/mygolf.data';
import * as moment from 'moment';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import { encodeSpaces, ensureHttpPrefix } from 'src/providers/common-service';
import { Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { EventsType } from '../comp-league-events-list/comp-league-events-list.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import html2pdf from 'html2pdf.js';
import { PageCaptureService } from 'services/page-capture-service/page-capture.service';

@Component({
  selector: 'app-comp-events-details',
  templateUrl: './comp-events-details.component.html',
  styleUrls: ['./comp-events-details.component.scss'],
})
export class CompEventsDetailsComponent implements OnInit {
  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  @Input() promoAds: OfferAndAdvertisement;
  @Input() event: any; //EventsType;
  slideOpts: any;
  @ViewChild('captureArea', { read: ElementRef }) captureArea!: ElementRef;
  isCapturing = false;
  constructor(
    private modalCtrl: ModalController,
    private mg2uUtil: mygolfUtils,
    private router: Router,
    private platform: Platform,
    private iab: InAppBrowser,
    private redirectService: RedirectService,
    private sanitizer: DomSanitizer,
    private pageCaptureService: PageCaptureService,
    private loadingController: LoadingController,
    private toastController: ToastController
  ) {
    this.slideOpts = {
      initialSlide: 0,
      slidesPerView: !this.isMobileLayout() ? 2.4 : this.isMobileLayout() ? 1.1 : 4,
      speed: 400,
      spaceBetween: 15,
      responsiveClass: true,
      // scrollbar:{
      //   el:'.swiper-scrollbar',
      //   draggable:true,
      // }
    };
  }

  ngOnInit() {
    // console.log('promo ads details',this.promoAds);
    if (this.event) {
      this.sanitizeEvent();
    }
  }

  backRouting() {
    this.modalCtrl.dismiss();
  }

  getPromoAdsImage(imageUrl: string) {
    // console.debug("get promoAds image", imageUrl);
    return encodeSpaces(imageUrl);
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  getPromoAdsOwnerDetails(attribute: string) {
    if (!this.promoAds) return;
    switch (attribute) {
      case 'name':
        if (this.promoAds?.club) return this.promoAds?.club?.name;
        else if (this.promoAds?.partner) return this.promoAds?.partner?.name;
        else return '';
      case 'country':
        if (this.promoAds?.club) return this.promoAds?.club?.countryName;
        else if (this.promoAds?.partner) return this.promoAds?.partner?.country?.name;
        else return '';
    }
  }

  getPromoAdsDetails(attribute: string) {
    if (!this.promoAds) return;
    switch (attribute) {
      case 'date':
        if (!this.promoAds?.startDate) return '-';
        return moment(this.promoAds?.startDate, 'YYYY-MM-DD').format('dddd, DD MMM YYYY');
      case 'time':
        if (!this.promoAds?.startTime) return '-';
        return moment(this.promoAds?.startTime, 'HH:mm:ss').format('hh:mm a');
    }
  }

  getPromoAdsOwnerImage() {
    // console.debug("get promoAds owner image", this.promoAds);
    if (!this.promoAds) return '/assets/image/default_club.png';
    if (this.promoAds?.club) {
      if (this.promoAds?.club?.clubLogo) return encodeSpaces(this.promoAds?.club?.clubLogo);
      else if (this.promoAds?.club?.clubImage) return encodeSpaces(this.promoAds?.club?.clubImage);
      else if (this.promoAds?.club?.clubThumbnail)
        return encodeSpaces(this.promoAds?.club?.clubThumbnail);
    } else if (this.promoAds?.partner) {
      if (this.promoAds?.partner?.partnerImage)
        return encodeSpaces(this.promoAds?.partner?.partnerImage);
      else return '/assets/image/default_club.png';
    } else return '/assets/image/default_club.png';
  }

  async onZoomImage(image: string) {
    const modal: any = await this.modalCtrl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: image,
        // description: _description,
        // descTopDown: 'top'
      },
    });
    await modal.present();
  }

  hasPromoAdsOwner() {
    if (!this.promoAds) return;
    if (this.promoAds?.club) return true;
    else if (this.promoAds?.partner) return true;
    else return;
  }

  hasViewMore() {
    if (!this.promoAds) return;
    if (this.promoAds.onClick) {
      if (this.promoAds?.onClick?.actionType === 'None') return false;
      else return true;
    } else return false;
  }

  onClickMore() {
    // console.debug("on click promo ads ", this.promoAds)
    let _onClickAction: OnClickAction = this.promoAds?.onClick;
    let _actionValue = '';
    if (_onClickAction?.actionValue) _actionValue = _onClickAction.actionValue;
    if (_onClickAction?.actionType) {
      switch (_onClickAction.actionType) {
        case 'None':
          break;
        case 'OpenUrl':
          let _url = ensureHttpPrefix(_actionValue);
          if (this.platform.is('capacitor')) {
            this.openWithInAppBrowser(_url);
          } else {
            let win = window.open(_url, '_system');
          }
          break;
        case 'OpenPage':
          this.goOpenPage(this.promoAds);
          // this.promoAdsListPage.goOpenPage(this.promoAds);
          // this.modalCtrl.dismiss().then(()=>{
          //   this.router.navigate([_actionValue]);
          // })
          break;
        default:
      }
    }
  }

  public openWithInAppBrowser(url: string, target?: string) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
      });
    }
    _iab.on('exit').subscribe(
      () => {},
      err => {}
    );
  }

  parseActionValue(data: any) {
    if (!data) return;
    if (data?.onClick === undefined) return;
    if (!data?.onClick?.actionValue) return;

    let actionValueObj = JSON.parse(data.onClick.actionValue);
    return actionValueObj;
  }

  public goOpenPage(promoAds: OfferAndAdvertisement) {
    const actionValue = this.parseActionValue(promoAds);
    const pageType: PromoPageType = actionValue?.pageType;
    if (pageType === 'tBooking') {
      let _params = {
        clubId: actionValue?.pageActionId,
        startDate: promoAds?.startDate,
        endDate: promoAds?.endDate,
        fromTime: actionValue?.fromTime,
        toTime: actionValue?.toTime,
      };
      this.redirectService.goToBookingSlotList(_params).then((result: any) => {
        if (result?.status === 'success') {
          this.modalCtrl.dismiss();
          console.debug('redirect done : ', result, _params);
          this.router.navigate([result?.page], {
            state: result?.params,
          });
        }
      });
    } else if (pageType === 'competition') {
      let _params = {
        competitionId: actionValue?.pageActionId,
        startDate: promoAds?.startDate,
        endDate: promoAds?.endDate,
        fromTime: actionValue?.fromTime,
        toTime: actionValue?.toTime,
      };
      this.redirectService.goToCompetitionDetails(_params).then((result: any) => {
        if (result?.status === 'success') {
          this.modalCtrl.dismiss();
          console.debug('redirect done : ', result, _params);
          this.router.navigate([result?.page], {
            state: result?.params,
          });
        }
      });
    } else if (pageType === 'stayAndPlay') {
      let _params = {
        packageId: actionValue?.pageActionId,
        startDate: promoAds?.startDate,
        endDate: promoAds?.endDate,
        fromTime: actionValue?.fromTime,
        toTime: actionValue?.toTime,
        previousPage: 'promo-ads-list',
      };
      this.redirectService.goToStayPlayPackage(_params).then((result: any) => {
        if (result?.status === 'success') {
          this.modalCtrl.dismiss();
          console.debug('redirect done : ', result, _params);
          this.router.navigate([result?.page], {
            state: result?.params,
          });
        }
      });
    } else if (pageType === 'handicapApplication') {
      let _params = {
        programId: actionValue?.pageActionId,
        startDate: promoAds?.startDate,
        endDate: promoAds?.endDate,
        fromTime: actionValue?.fromTime,
        toTime: actionValue?.toTime,
        partnerId: promoAds?.partner?.id,
      };
      this.redirectService.goToHandicapApplication(_params).then(async (result: any) => {
        if (result?.status === 'success') {
          console.debug('going to handicap application', _params, result);
          this.modalCtrl.dismiss();
          const modal = await this.modalCtrl.create({
            component: HandicapMembershipAddPage,
            componentProps: {
              player: result?.params?.state?.player,
              // application: renew ? app : retryPayment ? app : null,
              fromPromo: true,
              selectedDiscountProgram: result?.params?.state?.partnerProgram?.id,
              selectedDiscountCompany: result?.params?.state?.selectedDiscountCompany,
              retryPayment: false,
            },
          });

          modal.onDidDismiss().then((data: any) => {
            if (data) {
            }
          });
          await modal.present();
          console.debug('redirect done : ', result, _params);
        }
      });
    } else {
      let _actionValue = actionValue?.pageActionId;
      if (_actionValue) {
        this.router.navigate([_actionValue]);
      }
    }
  }

  sanitizedContent: SafeHtml;
  sanitizeEvent() {
    const eventContent = this.event.eventDetails;
    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(eventContent);
  }

  async captureAsImage(): Promise<void> {
    await this.performCapture('image');
  }

  async captureAsPdf(): Promise<void> {
    await this.performCapture('pdf');
  }

  private async performCapture(format: 'image' | 'pdf'): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: format === 'image' ? 'Preparing screenshot...' : 'Preparing PDF...',
      spinner: 'crescent',
      duration: 5000,
    });

    await loading.present();

    try {
      // const currentRound = this.gameRound?.roundNo || 1;
      const currentDateTime = moment().format('YYYYMMDD_HHmmss');
      // const filename = `compFlights${this.compData?.id}-round${currentRound}_${currentDateTime}`;
      const filename = `eventProgramDetails_${currentDateTime}`;
      const element = this.captureArea?.nativeElement;
      if (!element) {
        throw new Error('Content area not found');
      }

      // Dismiss loading BEFORE capture to avoid capturing the loading dialog
      // await loading.dismiss();

      // Wait for dismiss animation to complete and UI to settle
      await new Promise(resolve => setTimeout(resolve, 400));

      // For full-page capture, we need to get the scroll content
      // Try to get the parent ion-content to get scroll dimensions
      const ionContent = element.closest('ion-content');
      const scrollElement = ionContent ? (ionContent as any).scrollElement : null;

      // If we found the scroll element, use it for capture to get full height
      const captureElement = scrollElement || element;

      // Perform the capture
      const blob =
        format === 'image'
          ? await this.pageCaptureService.capturePageAsImage({
              element: captureElement,
              filename,
              format: 'image',
              quality: 0.95,
              backgroundColor: '#ffffff',
              delay: 300, // Reduced delay since we already waited
            })
          : await this.pageCaptureService.capturePageAsPdf({
              element: captureElement,
              filename,
              format: 'pdf',
              delay: 300, // Reduced delay since we already waited
            });

      if (blob) {
        await this.pageCaptureService.saveAndShare(blob, filename, format);

        const message =
          format === 'image' ? 'Screenshot captured successfully!' : 'PDF generated successfully!';

        await this.showToast(message, 'success');
      }
    } catch (error) {
      console.error('Capture error:', error);
      await this.showToast('Error capturing page. Please try again.', 'danger');
    } finally {
      // Ensure loading is dismissed in case of error
      try {
        await loading.dismiss();
      } catch (e) {
        // Loading already dismissed, ignore error
      }
      this.isCapturing = false;
    }
  }

  private async showToast(message: string, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color,
      position: 'bottom',
    });
    await toast.present();
  }

  /**
   * Export page as PDF using browser's native print functionality.
   * This captures the entire page including scrollable content.
   */
  async exportAsPdfNative(): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: 'Preparing PDF...',
      spinner: 'crescent',
    });

    await loading.present();

    try {
      // Dismiss loading before print dialog
      await loading.dismiss();
      await new Promise(resolve => setTimeout(resolve, 200));

      // Store original body styles
      const originalBodyOverflow = document.body.style.overflow;
      const originalBodyHeight = document.body.style.height;

      // Ensure page is fully visible for print
      document.body.style.overflow = 'visible';
      document.body.style.height = 'auto';

      // Use browser's native print (which can save as PDF)
      window.print();

      // Restore body styles after a short delay
      setTimeout(() => {
        document.body.style.overflow = originalBodyOverflow;
        document.body.style.height = originalBodyHeight;
      }, 1000);

      this.isCapturing = false;
    } catch (error) {
      console.error('Native PDF export error:', error);
      await this.showToast('Error exporting PDF. Please try again.', 'danger');
      this.isCapturing = false;
    }
  }

  /**
   * Export page as PDF using html2pdf.js library.
   * This library handles full-page HTML to PDF conversion better than manual capture.
   */
  async exportAsPdfWithLibrary(): Promise<void> {
    if (this.isCapturing) return;

    this.isCapturing = true;
    const loading = await this.loadingController.create({
      message: 'Generating PDF...',
      spinner: 'crescent',
    });

    await loading.present();

    try {
      const filename = `event-details-${new Date().getTime()}`;
      const element = this.captureArea?.nativeElement;
      if (!element) {
        throw new Error('Content area not found');
      }

      await loading.dismiss();
      await new Promise(resolve => setTimeout(resolve, 300));

      // For full-page capture, get the ion-content scroll element
      const ionContent = element.closest('ion-content');
      const scrollElement = ionContent ? (ionContent as any).scrollElement : null;
      const captureElement = scrollElement || element;

      const opt = {
        margin: [10, 10, 10, 10] as [number, number, number, number],
        filename: `${filename}.pdf`,
        image: {
          type: 'jpeg' as 'jpeg' | 'png' | 'webp',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          scrollY: 0,
          scrollX: 0,
          windowHeight: captureElement.scrollHeight,
          windowWidth: captureElement.scrollWidth,
        },
        jsPDF: {
          unit: 'mm' as 'mm' | 'cm' | 'in' | 'pt' | 'px' | 'pc',
          format: 'a4' as string,
          orientation: 'portrait' as 'portrait' | 'landscape',
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] as ('avoid-all' | 'css' | 'legacy')[] },
      } as any; // Cast to any to bypass strict type checking for html2pdf.js

      await html2pdf().set(opt).from(captureElement).save();

      await this.showToast('PDF generated successfully!', 'success');
    } catch (error) {
      console.error('html2pdf error:', error);
      await this.showToast('Error generating PDF. Please try again.', 'danger');
    } finally {
      this.isCapturing = false;
    }
  }

  async moreOptions() {
    let _dataList = [
      {
        id: 'downloadPdf',
        name: 'Download Program Info (PDF)',
        // iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'downloadImage',
        name: 'Download Program Info (Image)',
        // iconUrl: 'assets/icons/book.png',
      },
    ];
    const modal = await this.modalCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'More Options',
        // subTitle: this.leagueRounds ? this.leagueRounds[0].seasonName : '',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        switch (data?.data?.id) {
          case 'downloadPdf':
            this.performCapture('pdf');
            break;
          case 'downloadImage':
            this.performCapture('image');
            break;
        }
      }
    });
  }
}
